export interface AdvertViewVehicleValuationDTO {
  priceClean?: number;
  priceAvg?: number;
  priceRetail?: number;
}
